import { render, staticRenderFns } from "./recmain.vue?vue&type=template&id=bcd3295e&scoped=true"
import script from "./recmain.vue?vue&type=script&lang=js"
export * from "./recmain.vue?vue&type=script&lang=js"
import style0 from "./recmain.vue?vue&type=style&index=0&id=bcd3295e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3295e",
  null
  
)

export default component.exports